import Link from "next/link";

export default function ProjectCard({ project, style }) {
  return (
    <Link href={`/work/${project.id}`} className="px-feat-card" style={style}>
      <div className="px-feat-card-media">
        <div className="px-pill">{project.kind}</div>
        {project.video ? (
          <video src={project.video} autoPlay muted loop playsInline />
        ) : (
          <img src={project.image} alt={project.title} />
        )}
      </div>
      <div className="px-feat-card-title">{project.title} →</div>
    </Link>
  );
}
